import { render, staticRenderFns } from "./Reorder_level.vue?vue&type=template&id=14036ca0&"
import script from "./Reorder_level.vue?vue&type=script&lang=js&"
export * from "./Reorder_level.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports